import { utils } from "@mc/mc-legacy";
const { ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl } = utils;
export default class CustomPrehledApi {
  static exportOverview(filter = {}) {
    const uri = `${window.moduleContextPath}/api/overview/export`;
    return JsonFetch.post(uri, {}, filter).then((response) => {
      if (response.status !== 200) {
        throw new Error(`Server odpověděl ${response.status} ${response.statusText}`);
      }

      return response.blob();
    });
  }
}
